<template>
  <div class="color-picker">
    <!-- Dynamic Colours -->
    <template v-if="allowDynamics">
      <q-item-label header class="text-bold q-pa-none">
        Dynamic Colours:
      </q-item-label>
      <slot name="dynamic-description" />
      <div class="swatch">
        <ColorChip
          :color="dynamicColors.primary"
          :selected="modelValue === 'primary'"
          :disable="disable"
          label="Primary"
          @click="updateValue('primary', false)"
        />
        <ColorChip
          :color="dynamicColors.accent"
          :selected="modelValue === 'accent'"
          :disable="disable"
          label="Accent"
          @click="updateValue('accent', false)"
        />
      </div>
      <q-separator class="q-mb-sm" />
    </template>

    <q-color
      :key="tab"
      :model-value="!isTransparent ? modelValue : null"
      :default-view="tab"
      :disable="disable"
      format-model="hex"
      no-header
      no-footer
      flat
      style="width: 100%;"
      @update:model-value="updateValue"
    />

    <div v-if="!hideToolbar" class="color-toolbar q-pt-sm flex justify-between items-center">
      <q-btn-toggle
        v-model="tab"
        :options="tabOptions"
        :disable="disable"
        flat
        padding="sm sm"
        @update:model-value="$emit('changeTab', $event)"
      />
      <q-input
        v-if="!hasDynamicValue && !disable"
        :model-value="(!isTransparent ? modelValue : '').toUpperCase()"
        dense
        outlined
        mask="\#NNNNNN"
        placeholder="Hex Colour"
        style="max-width: 125px"
        @update:model-value="updateValue"
      >
        <template v-if="!isTransparent" #prepend>
          <ColorBadge :value="modelValue" dense />
        </template>
      </q-input>
      <q-btn
        v-if="clearable"
        label="Clear"
        padding="sm sm"
        size="12px"
        flat
        :disable="isTransparent || disable"
        @click="onClearColor"
      />
    </div>
  </div>
</template>

<script>
import ColorBadge from './ColorBadge'
import ColorChip from './partials/ColorChip'

/**
 * Uses default QColor but adds it as a popover element
 */
export default {
  components: {
    ColorChip, ColorBadge
  },
  props: {
    modelValue: {
      type: String,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    hideToolbar: {
      type: Boolean,
      default: false
    },
    allowDynamics: {
      type: Boolean,
      default: false
    },
    dynamicColors: {
      type: Object,
      default: null,
      validator: (value) => {
        return !!value && typeof value === 'object'
      }
    }
  },
  emits: ['update:modelValue', 'clear', 'changeTab'],
  data () {
    return {
      tab: 'palette',
      tabOptions: [
        { value: 'palette', icon: 'style' },
        { value: 'spectrum', icon: 'gradient' }
      ]
    }
  },
  computed: {
    hasDynamicValue () {
      return ['primary', 'accent'].includes(this.modelValue)
    },
    isTransparent () {
      return !this.modelValue || this.modelValue === 'transparent'
    }
  },
  methods: {
    updateValue (val, validate = true) {
      if (validate && !this.checkValidHexColor(val)) {
        return
      }
      this.$emit('update:modelValue', val)
    },
    onClearColor () {
      this.updateValue(null, false)
      this.$emit('clear')
    }
  }
}
</script>

<style lang="scss" src="./colorpicker.scss" />
